var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "header",
    { staticClass: "entry-layout-header" },
    [
      _c("span", { staticClass: "entry-layout-header-logo" }, [
        _c("img", { style: _vm.logoStyle, attrs: { src: _vm.logo } }),
      ]),
      _c(
        "div",
        { staticClass: "entry-layout-header-menus" },
        [
          _c(
            "a-dropdown",
            {
              staticClass: "entry-dropdown",
              attrs: { placement: "bottomLeft" },
              scopedSlots: _vm._u(
                [
                  _vm.menus.length === 0
                    ? {
                        key: "overlay",
                        fn: function () {
                          return [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  padding: "10px 15px",
                                  background: "#f8f8f8",
                                  "text-align": "center",
                                },
                              },
                              [
                                _c("a-empty", {
                                  attrs: {
                                    description: _vm.i18nRender(
                                      "layouts.text.undefined"
                                    ),
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      }
                    : {
                        key: "overlay",
                        fn: function () {
                          return [
                            _c(
                              "a-menu",
                              {
                                attrs: { slot: "overlay", selectedKeys: [""] },
                                on: { click: _vm.handleMenusChange },
                                slot: "overlay",
                              },
                              [
                                _c("a-menu-item", { key: "__HISTORY__" }, [
                                  _c(
                                    "div",
                                    { staticClass: "entry-dropdown-menu" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "entry-dropdown-menu__hd",
                                        },
                                        [
                                          _c("icon-font", {
                                            attrs: {
                                              type: "gb-icon-icon_liwu_w",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "entry-dropdown-menu__bd",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.i18nRender(
                                                "layouts.commonmenu"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "entry-dropdown-menu__ft",
                                        },
                                        [
                                          _vm.menusActiveID &&
                                          _vm.menusActiveID === "__HISTORY__"
                                            ? _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    color: "#666666",
                                                    "font-weight": "bold",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.i18nRender(
                                                        "layouts.current"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    color: "#077bfc",
                                                  },
                                                },
                                                [
                                                  _c("a-icon", {
                                                    attrs: { type: "swap" },
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.i18nRender(
                                                          "layouts.switch",
                                                          []
                                                        )
                                                      )
                                                  ),
                                                ],
                                                1
                                              ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._l(_vm.customMenus, function (menu) {
                                  return _c("a-menu-item", { key: menu.key }, [
                                    _c(
                                      "div",
                                      { staticClass: "entry-dropdown-menu" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "entry-dropdown-menu__hd",
                                          },
                                          [
                                            menu.menuType === 1
                                              ? _c("icon-font", {
                                                  attrs: {
                                                    type: "gb-icon-kecheng-copy",
                                                  },
                                                })
                                              : _c("icon-font", {
                                                  attrs: {
                                                    type: "gb-icon-zidingyi",
                                                  },
                                                }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "entry-dropdown-menu__bd",
                                          },
                                          [_vm._v(_vm._s(menu.tab))]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "entry-dropdown-menu__ft",
                                          },
                                          [
                                            _c(
                                              "span",
                                              [
                                                _c("a-icon", {
                                                  directives: [
                                                    {
                                                      name: "demo",
                                                      rawName: "v-demo:[menu]",
                                                      value: "handleCustom",
                                                      expression:
                                                        "'handleCustom'",
                                                      arg: menu,
                                                    },
                                                  ],
                                                  attrs: { type: "edit" },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "span",
                                              [
                                                _c("a-icon", {
                                                  directives: [
                                                    {
                                                      name: "demo",
                                                      rawName: "v-demo:[menu]",
                                                      value: "handleDeleteMenu",
                                                      expression:
                                                        "'handleDeleteMenu'",
                                                      arg: menu,
                                                    },
                                                  ],
                                                  attrs: { type: "delete" },
                                                }),
                                              ],
                                              1
                                            ),
                                            _vm.menusActiveID &&
                                            _vm.menusActiveID === menu.key
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#666666",
                                                      "font-weight": "bold",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.i18nRender(
                                                          "layouts.current"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#077bfc",
                                                    },
                                                  },
                                                  [
                                                    _c("a-icon", {
                                                      attrs: { type: "swap" },
                                                    }),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.i18nRender(
                                                            "layouts.switch",
                                                            []
                                                          )
                                                        )
                                                    ),
                                                  ],
                                                  1
                                                ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ])
                                }),
                                [
                                  _c("a-menu-divider", {
                                    attrs: {
                                      rootPrefixCls: "home-ant-dropdown-menu",
                                    },
                                  }),
                                  _c("a-menu-item", { key: "addCustomMenus" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "entry-dropdown-menu",
                                        staticStyle: {
                                          "justify-content": "center",
                                        },
                                      },
                                      [
                                        _c(
                                          "a-button",
                                          {
                                            staticClass:
                                              "entry-dropdown-menu__btn",
                                            attrs: {
                                              size: "small",
                                              type: "link",
                                              icon: "plus-circle",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.i18nRender(
                                                  "layouts.customscene",
                                                  []
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                ],
                              ],
                              2
                            ),
                          ]
                        },
                        proxy: true,
                      },
                ],
                null,
                true
              ),
            },
            [
              _c(
                "div",
                { staticClass: "entry-dropdown__name" },
                [
                  _c("a-icon", {
                    attrs: { type: "appstore", theme: "filled" },
                  }),
                  _c("span", { staticStyle: { "margin-left": "8px" } }, [
                    _vm._v(
                      _vm._s(
                        (_vm.menuInfo && _vm.menuInfo.tab) ||
                          (_vm.menusActiveID &&
                            _vm.menusActiveID === "__HISTORY__" &&
                            _vm.i18nRender("layouts.commonmenu")) ||
                          _vm.i18nRender("layouts.application")
                      )
                    ),
                  ]),
                  _c("a-icon", {
                    staticStyle: { "margin-left": "5px", "font-size": "12px" },
                    attrs: { type: "caret-down" },
                  }),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c("a-divider", { attrs: { type: "vertical" } }),
      _vm.selectedMenus
        ? _c("entry-menus", {
            attrs: { menu: _vm.selectedMenus, currentLang: _vm.currentLang },
            on: { click: _vm.handleMenuChange },
          })
        : _vm._e(),
      _c("div", { staticClass: "entry-layout-header-nav" }, [
        _c(
          "div",
          { staticClass: "entry-layout-header-nav__main" },
          _vm._l(_vm.customTabs[0], function (tab) {
            return _c(
              "div",
              {
                key: tab.key,
                staticClass: "entry-layout-header-nav__item",
                on: {
                  click: function ($event) {
                    return _vm.handleMenuChange(tab.key)
                  },
                },
              },
              [_vm._v(_vm._s(_vm._f("menuLocalName")(tab)))]
            )
          }),
          0
        ),
        _c(
          "div",
          { staticClass: "entry-layout-header-nav__extra" },
          [
            _vm.customTabs[1].length
              ? _c(
                  "a-dropdown",
                  {
                    staticClass: "entry-dropdown",
                    attrs: { placement: "bottomLeft" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "overlay",
                          fn: function () {
                            return [
                              _c(
                                "a-menu",
                                {
                                  attrs: {
                                    slot: "overlay",
                                    selectedKeys: [""],
                                  },
                                  on: { click: _vm.handleMenuClick },
                                  slot: "overlay",
                                },
                                _vm._l(_vm.customTabs[1], function (menu) {
                                  return _c("a-menu-item", { key: menu.key }, [
                                    _c(
                                      "div",
                                      { staticClass: "entry-dropdown-menu" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "entry-dropdown-menu__bd",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("menuLocalName")(menu)
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ])
                                }),
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      372039463
                    ),
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "entry-layout-header-nav__btn" },
                      [_c("a-icon", { attrs: { type: "dash" } })],
                      1
                    ),
                  ]
                )
              : _vm._e(),
            _vm.menusActiveID && _vm.menuInfo
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "demo",
                        rawName: "v-demo:[menuInfo]",
                        value: "handleCustom",
                        expression: "'handleCustom'",
                        arg: _vm.menuInfo,
                      },
                    ],
                    staticClass: "entry-layout-header-nav__btn",
                  },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "24px",
                          "vertical-align": "-2px",
                          "line-height": "1",
                        },
                      },
                      [_vm._v("+")]
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._t("rightContentRender"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }